// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceSpecInfo
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { InputArgumentSpec } from "abweb/dto/gds/InputArgumentSpec";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DataSourceSpecInfoBase {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceSpecInfoBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceSpecInfo";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceSpecInfo(json.id != null ? json.id : null, json.inputArgs != null ? TSOGUtils.decodeObjectArray(json.inputArgs, InputArgumentSpec, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "inputArgs")) : null);
  }
  initDataSourceSpecInfo(id, inputArgs) {
    this._id = id;
    this._inputArgs = inputArgs;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["id"] = this._id;
    retVal["inputArgs"] = TSOGUtils.toTSOGArray(this._inputArgs, serializeContext);
    return retVal;
  }
  get id() {
    return this._id;
  }
  set id(value) {
    this._id = value;
  }
  get inputArgs() {
    return this._inputArgs;
  }
  set inputArgs(value) {
    this._inputArgs = value;
  }
}
//# sourceMappingURL=DataSourceSpecInfoBase.js.map
